import api from "./api";
const endpoint = "volontariat/AssociationExperience";
const domaineEndpoint = "ExternalCV";
export const AssociationExperienceService = {
  async getAll(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneByID(id) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: { id_ext_asso_exp: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async insert(data, file_data = null) {
    try {
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      if (file_data) {
        formData.append("file_exp", file_data);
      }
      const result = await api.post(endpoint + "/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(data, file_data = null) {
    try {
      const formData = new FormData();
      formData.append("data", JSON.stringify(data));
      if (file_data) {
        formData.append("file_exp", file_data);
      }
      const result = await api.post(endpoint + "/update", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },

  async delete(data) {
    try {
      const result = await api.post(endpoint + "/delete", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getDomaineCompetenceById(id) {
    try {
      const result = await api.get(domaineEndpoint + "/domaine_competence_detail", {
        params: { id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getDomaineList(filtre) {
      try {
        const result = await api.get(domaineEndpoint + "/liste_domaine", {
          params: filtre,
        });
        if (result) {
          return result.data;
        }
      } catch (error) {
        if (error.response) {
          return error.response.data;
        }
      }
    },
  async getSousDomaineList(filtre) {
    try {
      const result = await api.get(domaineEndpoint + "/liste_sous_domaine", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
